


















import Vue from 'vue';
import CustomType from '../../src/types/vue';


export interface ComponentApp extends Vue {
  langue: string,
}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: 'CompteARebours',
  props: {

  },
  data () {
    return {
    }
  },
  methods: {

  },
  components: {
  },
  mounted: function(){
    if(typeof window['CountBack'] === "function")
      window['CountBack'](window['gsecs']);
  }
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/CompteARebours.vue